var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75a.954.954 0 01-.707-.32l-6-6.563a1.167 1.167 0 010-1.547.94.94 0 011.414 0L7 6.111l5.293-5.79a.94.94 0 011.414 0c.39.428.39 1.12 0 1.547l-6 6.562A.955.955 0 017 8.75z"
  })));
}
export default SvgChevron;